module.exports = __webpack_public_path__ + "static/media/Textbox.aed434c9.png";